import React, { useEffect, useRef, useState } from 'react';
import { DollarSign } from 'lucide-react';

const AdSenseCard = ({
  adClient = "ca-pub-XXXXXXXXXX", // Replace with your AdSense client ID
  adSlot = "YYYYYYYYYY",           // Replace with your ad slot ID
  index = 0,
  showPlaceholder = true,          // Set to false once you add real AdSense IDs
  customHeight = null              // Custom height override (e.g., '180px')
}) => {
  const adRef = useRef(null);
  const isAdPushed = useRef(false);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (!adRef.current || showPlaceholder) return;

    // Create Intersection Observer to detect when ad card is in viewport
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Card is in view, load immediately
            if (!isAdPushed.current) {
              console.log('AdSense: Card entering viewport, loading ad...');
              setIsInView(true);
            }
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the card is visible
        rootMargin: '50px' // Start loading slightly before card enters viewport
      }
    );

    observer.observe(adRef.current);

    return () => {
      observer.disconnect();
    };
  }, [showPlaceholder]);

  useEffect(() => {
    // Load ad when in view
    if (isInView && !isAdPushed.current && !showPlaceholder) {
      try {
        const loadAd = () => {
          if (window.adsbygoogle) {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
            isAdPushed.current = true;
            console.log('AdSense ad loaded for slot:', adSlot);
          } else {
            // Script not loaded yet, retry
            console.log('AdSense: Script not ready, retrying...');
            setTimeout(loadAd, 100);
          }
        };

        loadAd();
      } catch (e) {
        console.error('AdSense error:', e);
      }
    }
  }, [isInView, showPlaceholder, adSlot]);

  return (
    <div className="ad-card">
      <div className="ad-card-header">
        <div className="ad-card-label">
          <span className="ad-label-full">Advertisement</span>
          <span className="ad-label-short">Ads</span>
        </div>
      </div>
      <div className="ad-card-content">
        {showPlaceholder ? (
          // Placeholder shown before AdSense is configured
          <div className="ad-container">
            <div className="ad-placeholder">
              <DollarSign className="ad-placeholder-icon" />
              <div className="ad-placeholder-text">Ad Space</div>
              <div className="ad-placeholder-subtext">
                AdSense placement {Math.floor(index / 5) + 1}
              </div>
            </div>
          </div>
        ) : (
          // Real AdSense ad
          <div ref={adRef} style={{ width: '100%', minHeight: customHeight || '250px', height: customHeight || 'auto' }}>
            <ins
              className="adsbygoogle"
              style={{
                display: 'block',
                width: '100%',
                minHeight: customHeight || '250px',
                height: customHeight || 'auto'
              }}
              data-ad-client={adClient}
              data-ad-slot={adSlot}
              data-ad-format="auto"
              data-full-width-responsive="true"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdSenseCard;
